<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{ title }}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>

        <div v-else>
          <CForm>
            <CRow>
              <CCol sm="3">
                <CInput
                  label="Name"
                  invalid-feedback="name should be filled"
                  required
                  v-model="$v.productCategoryForm.name.$model"
                  :is-valid="!$v.productCategoryForm.name.$invalid"
                />
              </CCol>
              <CCol sm="3">
                <div class="form-group">
                  <label for="group">Group</label>
                  <model-select
                    class="form-control"
                    id="group"
                    :options="groupList"
                    v-model="$v.productCategoryForm.group.$model"
                    :isError="$v.productCategoryForm.group.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="$v.productCategoryForm.group.$invalid"
                    class="invalid-feedback-custom"
                  >
                    Group should be filled.
                  </div>
                </div>
              </CCol>
              <CCol sm="3">
                <label>Installment</label><br />
                <CInputRadioGroup
                  class="col-sm-9"
                  :options="options"
                  :custom="true"
                  :checked="productCategoryForm.flag"
                  :inline="true"
                  @update:checked="(option) => (productCategoryForm.flag = option)"
                />
                <div
                  v-if="$v.productCategoryForm.flag.$invalid"
                  class="invalid-feedback-custom"
                >
                  Installment condition should be filled.
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CTextarea
                  rows="4"
                  label="Description"
                  invalid-feedback="Description should be filled"
                  required
                  v-model="$v.productCategoryForm.description.$model"
                  :is-valid="!$v.productCategoryForm.description.$invalid"
                />
                <!-- <label for="nik">Description</label>
                <quill-editor
                  style="height: 200px; margin-bottom: 70px"
                  :content="content"
                  :options="editorOption"
                  v-model="$v.productCategoryForm.description.$model"
                  @change="onEditorChange($event)"
                >
                </quill-editor>
                <div
                  v-if="$v.productCategoryForm.description.$invalid"
                  class="invalid-feedback-custom"
                >
                  Description harus di isi.
                </div> -->
              </CCol>
            </CRow>
          </CForm>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton
              color="danger"
              title="Edit"
              size="sm"
              class="text-center"
              @click="back"
            >
              <i class="fa fa-undo"></i> Back </CButton
            >&nbsp;
            <CButton
              color="success"
              :disabled="$v.productCategoryForm.$invalid"
              title="Detail"
              size="sm"
              @click="save"
            >
              <i class="fa fa-edit" /> Save
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>

    <CCard>
      <CCardBody>
        <CTabs :active-tab.sync="activeTab">
          <CTab>
            <template slot="title"> Sub Category </template>
            <br />
            <GlobalTable
              :title="'Sub Category'"
              :fields="fields"
              :items="items"
              :editButton="true"
              :redirectDetail="false"
              :enableAddButton="true"
              :isLoading="isLoading"
              :withCard="false"
              @addForm="addForm"
              @editForm="editForm"
            ></GlobalTable>
          </CTab>

          <CTab>
            <template slot="title">Images Category</template>
            <br />
            <ProductCategoryImages
              :productCategory.sync="productCategoryForm"
            ></ProductCategoryImages>
          </CTab>
        </CTabs>
      </CCardBody>
    </CCard>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CRow>
          <CCol sm="3">
            <CInput
              label="Name"
              invalid-feedback="name should be filled"
              required
              v-model="$v.subCategoryForm.name.$model"
              :is-valid="!$v.subCategoryForm.name.$invalid"
            />
          </CCol>
          <CCol sm="3">
            <label>Installment</label><br />
            <CInputRadioGroup
              class="col-sm-9"
              :options="options"
              :custom="true"
              :checked="subCategoryForm.flag"
              :inline="true"
              @update:checked="(option) => (subCategoryForm.flag = option)"
            />
            <div v-if="$v.subCategoryForm.flag.$invalid" class="invalid-feedback-custom">
              Installment condition should be filled.
            </div>
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="12">
            <!-- <label for="nik">Description</label>
            <quill-editor style="height: 200px; margin-bottom:70px;"
              :content="contentSub"
              :options="editorOption"
              v-model="$v.subCategoryForm.description.$model"
              @change="onEditorChangeSub($event)">
            </quill-editor>
            <div v-if="$v.subCategoryForm.description.$invalid" class="invalid-feedback-custom">
              Description harus di isi.
            </div> -->
            <CTextarea
              rows="4"
              label="Description"
              invalid-feedback="Description should be filled"
              required
              v-model="$v.subCategoryForm.description.$model"
              :is-valid="!$v.subCategoryForm.description.$invalid"
            />
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="submitForm"
          :disabled="$v.subCategoryForm.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "../../../templates/Loading";

import ProductCategoryImages from "./tabs/ProductCategoryImages";

import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";

export default {
  name: "ProductCategoryDetail",
  components: { GlobalTable, Loading, quillEditor, ProductCategoryImages },
  data() {
    return {
      title: "Product Category Detail",
      categoryList: [],
      groupList: [],
      items: [],
      productCategoryForm: tableInterfaces.product_category,
      subCategoryForm: tableInterfaces.product_category,
      isLoading: false,
      activeTab: 0,
      isEdit: false,
      fields: [
        { key: "name", label: "Name", sorter: true },
        { key: "installment_name", label: "Installment", sorter: true },
        { key: "description", label: "Description", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
      addButton: false,
      content: "",
      editorOption: {}, // data quill
      contentSub: "",
      editorOption: {}, // data quill
      options: [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" },
      ],
    };
  },
  validations: {
    productCategoryForm: {
      name: { required },
      parent: {},
      group: { required },
      flag: { required },
      description: { required },
    },
    subCategoryForm: {
      name: { required },
      flag: { required },
      description: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function (id) {
      this.getDetailProductCategory(id);
      this.getDropdown();
    },
    back: function () {
      this.$router.go(-1);
    },
    getDropdown: function () {
      this.axios.get("/console/master/product_category/dropdown").then((response) => {
        this.categoryList = response.data.category;
        this.groupList = response.data.group;
      });
    },
    getDetailProductCategory: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/master/product_category/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.productCategoryForm = response.data.data;
            this.items = response.data.data_sub;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.isEdit = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.isEdit = true;
      this.subCategoryForm = item;
      this.addButton = true;
    },
    resetForm: function () {
      for (var i in tableInterfaces.product_category) {
        tableInterfaces.product_category[i] = null;
      }
      this.subCategoryForm = tableInterfaces.product_category;
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        this.axios
          .put("console/master/product_category/update", this.productCategoryForm)
          .then((response) => {
            this.showInfoNotification({
              title: "Ubah Delivery",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Ubah Delivery");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    submitForm: function (event) {
      event.preventDefault();
      let route = this.$route.path.split("/");
      if (this.isEdit === true) {
        if (confirm("Apakah anda ingin merubah Data ini ?")) {
          this.isLoading = true;
          this.axios
            .put("console/master/product_category/edit_subcategory", this.subCategoryForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.addButton = false;
              this.init(route[4]);
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambah Data ini ?")) {
          let route = this.$route.path.split("/");
          this.subCategoryForm.parent = route[4];
          this.axios
            .post("console/master/product_category/add_subcategory", this.subCategoryForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.addButton = false;
              this.init(route[4]);
            });
        }
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html;
      this.productCategoryForm.description = html;
    },
    onEditorChangeSub({ quill, html, text }) {
      this.contentSub = html;
      this.subCategoryForm.description = html;
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>
